import { bunja } from 'bunja';
import { atom } from 'jotai';

import Num from '@flipster/utils/num';

import { btcPricePrecision, pricePredictionBunja } from './state';

export const resultAnnouncementCardBunja = bunja(() => {
  const { pricePredictionAtom, pricePredictionMeAtom } = bunja.use(pricePredictionBunja);

  const latestResultAtom = atom((get) => {
    const me = get(pricePredictionMeAtom);
    return me?.history?.[me?.history?.length - 1] ?? null;
  });

  const roundAtom = atom((get) => {
    const me = get(pricePredictionMeAtom);
    return me?.history?.length ?? 0;
  });

  const resultStatusAtom = atom((get) => {
    const result = get(latestResultAtom);
    if (!result || !result.predictionSide || !result.eligible) return 'not_participated' as const;

    return result.predictionCorrect ? ('correct' as const) : ('incorrect' as const);
  });

  const myPredictionAtom = atom((get) => {
    const result = get(latestResultAtom);
    return result?.predictionSide;
  });

  const btcPriceChangeInfoAtom = atom((get) => {
    const result = get(latestResultAtom);
    if (!result) {
      return { btcPriceChange: '0', btcPriceDirection: 'UP' as const };
    }

    const snapshot = Num(result.snapshotPrice);
    const resultPrice = Num(result.resultPrice);
    const diff = resultPrice.minus(snapshot);

    return {
      btcPriceChange: diff.abs().toFixed(btcPricePrecision),
      btcPriceDirection: diff.gte(0) ? ('UP' as const) : ('DOWN' as const),
    };
  });

  const rewardAmountAtom = atom((get) => {
    const result = get(latestResultAtom);
    const status = get(resultStatusAtom);

    if (!result) return '0';

    if (status === 'correct') return result.reward ?? '0';
    if (status === 'incorrect') return result.hypotheticalReward;
    return result.highestReward;
  });

  const upRateAtom = atom((get) => {
    const result = get(latestResultAtom);
    if (result) return Math.round(result.upRate * 100);
    return Math.round((get(pricePredictionAtom)?.upRate ?? 0.5) * 100);
  });

  const downRateAtom = atom((get) => {
    const result = get(latestResultAtom);
    if (result) return Math.round(result.downRate * 100);
    return Math.round((get(pricePredictionAtom)?.downRate ?? 0.5) * 100);
  });

  const showResultAnnouncementAtom = atom((get) => {
    const prediction = get(pricePredictionAtom);
    const latestResult = get(latestResultAtom);

    return prediction?.pricePredictionStatus === 'ONGOING' && latestResult !== null;
  });

  return {
    roundAtom,
    resultStatusAtom,
    myPredictionAtom,
    btcPriceChangeInfoAtom,
    rewardAmountAtom,
    upRateAtom,
    downRateAtom,
    showResultAnnouncementAtom,
  };
});
resultAnnouncementCardBunja.debugLabel = 'resultAnnouncementCardBunja';
